export default "__VITE_ASSET__Oc$lBduu__"